import documentAPI from 'granite-admin/common/gateways/document-api';
async function uploadDocumentClicked(eventEmitter, values) {
  try {
    const {
      files,
      file_name,
      ext,
      ...rest
    } = values;
    const res = await Promise.allSettled(files.map(async file => {
      const obj = {
        file,
        file_name: files.length > 1 ? file.name.split('.')[0] : file_name,
        ext: files.length > 1 ? file.name.split('.')[1] : ext,
        ...rest
      };
      await uploadDocument(obj);
    }));
    const [success, failed] = res.reduce((acc, item) => {
      return item.status === 'fulfilled' ? [acc[0] + 1, acc[1]] : [acc[0], acc[1] + 1];
    }, [0, 0]);
    eventEmitter.emit('DOCUMENT_SAVE_SUCCESS', {
      success,
      failed
    });
    if (success > 0) eventEmitter.emit('FETCH_LIST');
    if (failed > 0) eventEmitter.emit('DOCUMENT_SAVE_FAILURE');
  } catch (error) {
    eventEmitter.emit('DOCUMENT_SAVE_FAILURE');
  }
}
async function uploadDocument({
  file,
  file_name,
  ext,
  target_object_id,
  target_content_type_id,
  target_content_type_name,
  document_type,
  document_sub_type
}) {
  // try {
  const {
    fields,
    url
  } = await documentAPI.getS3Url(`${file_name}.${ext}`);
  const fileData = new FormData();
  Object.keys(fields).forEach(field => {
    fileData.append(field, fields[field]);
  });
  fileData.append('file', file);
  await documentAPI.uploadS3(url, fileData);
  const payload = {
    document_name: file_name,
    document: fields['key'],
    target_object_id,
    target_content_type_id,
    target_content_type_name,
    document_type,
    document_sub_type
  };
  return await documentAPI.createDocument(payload);
  // } catch (e) {
  //   throw e;
  // }
}

export { uploadDocumentClicked, uploadDocument };